// columns/StatusColumn.tsx
import React from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import { Label, LabelStatus } from "../../../model/Label";
import Icon from "../../../components/ui/Icon";

const StatusCellRenderer = (params: GridRenderCellParams<Label>) => {
  const status = params.row.status;
  switch (status) {
    case LabelStatus.COMPLETED:
      return (
        <div className="flex items-center justify-center text-green-800  h-full w-auto">
          <Icon icon="check" />
        </div>
      );
    case LabelStatus.PENDING:
      return (
        <div className="flex items-center justify-center text-amber-900 h-full w-auto">
          <Icon icon="modify" />
        </div>
      );
    case LabelStatus.TRANSLATED:
      return (
        <div className=" flex items-center justify-center text-purple-700  h-full w-auto">
          <Icon icon="translate" />
        </div>
      );
  }
};

const StatusHeaderRenderer = () => (
  <Typography variant="subtitle2" fontWeight="medium">
    Status
  </Typography>
);

export const statusColumn: GridColDef = {
  field: "status",
  headerName: "Status",
  width: 60,
  hideable: false,
  headerClassName: "labels-table--header",
  renderHeader: StatusHeaderRenderer,
  renderCell: StatusCellRenderer,
  type: "singleSelect",
  valueOptions: [
    { value: LabelStatus.COMPLETED, label: "Completed" },
    { value: LabelStatus.PENDING, label: "Pending" },
    { value: LabelStatus.TRANSLATED, label: "Translated" },
  ],
};
